export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-lg mx-auto text-center">
          <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-secondary-100 text-secondary-700 mb-3 whitespace-nowrap">
            联系我们
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            投稿与合作
          </h2>
          <p className="text-sm text-foreground-600 leading-relaxed mb-8">
            欢迎漫画作者、汉化组、版权方与我们联系合作。如果你有优秀的漫画作品希望收录到99漫画网，或是有商务合作意向，请随时通过以下方式找到我们。我们珍视每一部好作品，也期待与更多创作者共同打造优质的漫画在线阅读平台。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-mail-line text-primary-500 text-lg"></i>
              <span>contact@99manhua.com</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-wechat-line text-accent-600 text-lg"></i>
              <span>99漫画官方公众号</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-twitter-x-line text-foreground-600 text-lg"></i>
              <span>@99manhua</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}